import ZModal from "@atoms/ZModal";
import React, { memo, useEffect, useState } from "react";
import { CongratulationGuideUIProps } from "./interface";
import ZTypography from "@atoms/ZTypography";
import { EFontWeights } from "@atoms/ZTypography/interface";
import ZButton from "@atoms/ZButton";
import { Player, PlayerEvent } from "@lottiefiles/react-lottie-player";
import "./index.less";
import { Card } from "antd";
import ZVideo from "@organisms/ZVideo";
import LottieConfetti from "../../assets/LottieConfetti.json";

const { ZText } = ZTypography;

const CongratulationGuideModal: React.FC<CongratulationGuideUIProps> = ({
	visible = false,
	description,
	title,
	handleNext,
	mediaUrl,
	illustration: Illustration,
	confirmText
}) => {
	const [visibleLottiePlayer, setVisibleLottiePlayer] = useState(false);
	const [modalVisible, setModalVisible] = useState(false);

	const handleConfirmNext = () => {
		setModalVisible(false);
		handleNext?.();
	};

	useEffect(() => {
		if (visible) setVisibleLottiePlayer(true);
	}, [visible]);

	const onFlashComplete = () => {
		setModalVisible(true);
		setVisibleLottiePlayer(false);
	};

	const onPlayerEvent = (event: PlayerEvent) => {
		if (event === PlayerEvent.Complete) onFlashComplete();
	};

	const media = mediaUrl ? (
		<ZVideo
			id={"guide-media-end-tutorial"}
			video={mediaUrl}
			isPreview
			loop
			autoPlay
			muted
			hasLoading={true}
		/>
	) : Illustration ? (
		<div className="flex justify-center items-center h-full">
			<Illustration />
		</div>
	) : null;

	return (
		<>
			<ZModal
				centered
				visible={modalVisible}
				size="sm"
				closable={false}
				footer={null}
				className="complete-module-modal rounded-lg"
				removeDefaultPadding
				zIndex={930}
			>
				<Card
					className="complete-modal-content"
					cover={media}
					bordered={false}
				>
					<div className="flex flex-col px-5 py-6">
						<div className="flex flex-col">
							<ZText level={1} weight={EFontWeights.MEDIUM}>
								{title}
							</ZText>
							<ZText className="pt-2">{description}</ZText>
						</div>
						<div className="mt-4 flex justify-end">
							<ZButton
								type="primary"
								className="rounded"
								onClick={handleConfirmNext}
							>
								{confirmText}
							</ZButton>
						</div>
					</div>
				</Card>
			</ZModal>
			{visibleLottiePlayer ? (
				<Player
					className="complete-module-player"
					src={LottieConfetti}
					autoplay
					loop={false}
					onEvent={onPlayerEvent}
				/>
			) : null}
		</>
	);
};

export default memo(CongratulationGuideModal);
